// extracted by mini-css-extract-plugin
export default {"container":"News_container__itvae"};